module.exports = __webpack_public_path__ + "static/media/play.337eae8d.svg";